import {Component, inject, OnInit} from '@angular/core';
import {Router, RouterModule} from '@angular/router';
import {CommonModule} from "@angular/common";
import {SecurityService} from "./security/security.service";
import {UserDataService} from "./security/user-data.service";
import {SsoUserService} from "./service/sso-user.service";
import {OidcSecurityService} from "angular-auth-oidc-client";
import {ConfirmDialogService} from "./shared/commons/dialog/confirm-dialog/confirm-dialog.service";


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'SRM';
  public router: Router = inject(Router);
  public authenService: SecurityService = inject(SecurityService);
  public userDataService: UserDataService = inject(UserDataService);
  private ssoUserResource = inject(SsoUserService);
  private oidcSecurityService  = inject(OidcSecurityService);
  isLoginConfirmDialogOpen = false;
  private confirmDialogService  = inject(ConfirmDialogService);

  constructor() {

  }

  ngOnInit(): void {
    this.authenService.checkAuth()
      .subscribe(loginResponse => {
        // console.log('AppComponent LoginResponse : ', loginResponse);
        if (loginResponse.isAuthenticated) {
          this.userDataService.getCurrent()
            .subscribe(user => {
              // console.log('user data ', user);
            });
          this.ssoUserResource.syncSsoUser().subscribe();
        }
      });

    this.oidcSecurityService.checkSessionChanged$.subscribe(e => {
      // console.log('checkSessionChanged$', e)
      if (e && !this.isLoginConfirmDialogOpen) {
        this.isLoginConfirmDialogOpen = true
        this.confirmDialogService.open({content: 'session หมดอายุ ต้องการล็อกอินอีกครั้งกด ยืนยัน?'}).subscribe(e => {
          if (e) {
            this.oidcSecurityService.logoff()
            this.oidcSecurityService.authorize()
          }
        })
      }
    })
    this.authenService.authorities$().subscribe(authorities => {
      // console.log(authorities);
    })
  }

  onActivate(event) {
    // let content = document.getElementById("content");
    // if (content) {
    //   content.scrollIntoView({
    //     behavior: 'smooth',
    //     block: 'start'
    //   });
    // }
  }
}
